var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"learning-project"}},[_c('el-tabs',{attrs:{"type":"border-card"}},_vm._l((_vm.item),function(i,index){return _c('el-tab-pane',{key:index,attrs:{"label":i.name}},[_c('ProjectItem',{attrs:{"item":i}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }